import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ClassificationModule } from '../classification/classification.module';
import { NavGroupComponent } from './navigation/nav-group/nav-group.component';
import { NavItemComponent } from './navigation/nav-item/nav-item.component';
import { DxMenuModule } from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule,
    LayoutRoutingModule,
    ClassificationModule
  ],
  declarations: [LayoutComponent, NavigationComponent, NavGroupComponent, NavItemComponent]
})
export class LayoutModule {}
